export const getOrgEmail = (orgCode: string) => {
  switch (orgCode) {
    case 'ZOLVE':
      return 'hello@zolve.com';
    default:
      return 'traveldesk@goniyo.com';
  }
};
